import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AlertModule } from 'ngx-bootstrap/alert';

import { AlertBannerComponent } from './alert-banner.component';
import { AlertBannerService } from './alert-banner.service';
import {BannerModule} from "@xref/xref-lib";

@NgModule({
  imports: [
    AlertModule.forRoot(),
    CommonModule,
    BannerModule
  ],
  declarations: [AlertBannerComponent],
  exports: [AlertBannerComponent]
})
export class AlertBannerModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: AlertBannerModule,
      providers: [AlertBannerService]
    };
  }
}
